export type SubscriptionTier = 'free' | 'pro';

export type SubscriptionStatus = 'active' | 'cancelled' | 'past_due' | 'paused';

export type BillingInterval = 'monthly' | 'yearly';

export const PRO_MONTHLY_PRICE = 3;
export const PRO_YEARLY_PRICE = 9;

export interface SubscriptionInfo {
  tier: SubscriptionTier;
  status?: SubscriptionStatus;
  currentPeriodEnd?: string;
  paddleSubscriptionId?: string;
  billingInterval?: BillingInterval;
}

export interface UsageInfo {
  dailySharesUsed: number;
  dailySharesLimit: number;
  maxPayloadSizeBytes: number;
}

export const TIER_LIMITS: Record<SubscriptionTier, { dailyShares: number; maxPayloadSizeBytes: number }> = {
  free: {
    dailyShares: 5,
    maxPayloadSizeBytes: 10 * 1024 * 1024, // 10MB
  },
  pro: {
    dailyShares: Infinity,
    maxPayloadSizeBytes: 100 * 1024 * 1024, // 100MB
  },
};
